<div class="field-block field-email">
  <div class="simple-text">{{ contact.email }}</div>
</div>
